import component from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-documents/lni-child-labor-complaint-documents.component.vue';
import module from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-documents/lni-child-labor-complaint-documents.module.js';

export default {
    component,
    module,
};